function pad(n) {
  return String(n).padStart(2, "0");
}

function fmt(d) {
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
}

// Build a keyless "Add to Google Calendar" link from a booking (no API key required).
export function googleCalendarUrl(b) {
  if (!b?.date) return "#";
  const [y, m, day] = b.date.split("-").map(Number);
  const [hh, mm] = (b.time || "12:00").split(":").map(Number);
  const start = new Date(y, m - 1, day, hh || 0, mm || 0);
  const end = new Date(start.getTime() + (b.hours || 3) * 3600000);
  const text = `Autobus Limo — ${b.service_label || "Reservation"}`;
  const details = [
    b.vehicle ? `Vehicle: ${b.vehicle}` : null,
    `Passengers: ${b.passengers}`,
    b.dropoff_location ? `Drop-off: ${b.dropoff_location}` : null,
    `Reference: ${b.id}`,
    "Booked with Autobus Limo Mont Royal",
  ].filter(Boolean).join("\n");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text,
    dates: `${fmt(start)}/${fmt(end)}`,
    details,
    location: b.pickup_location || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
